function configuratorShareAndSave(){
  $('span[data-share-configuration]').on('click', function(event) {
    event.preventDefault();
    $(event.target).text('...');
   
    let selectedVariants = $('body select[name=id],body  #summaryCharger div,body #summaryEnhancements div.enhancement');
    console.log('select V', selectedVariants);
    var selectedFormData = $.map(selectedVariants, function(obj) {
      return($(obj).val() ? { id: $(obj).val(), quantity: 1 } : $(obj).attr('value') ? { id: $(obj).attr('value'), quantity: 1 } : null);

    });
    console.log('selectedFrmDta', selectedFormData);
    let formData = {
      'items': selectedFormData
  };
     alert('WIP -- Save to customer Meta Data // Email/Share Form' + formData['items'].map((variant) => '\nVariant Id: ' + variant.id));
// fetch(window.Shopify.routes.root + 'cart/add.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify(formData)
// })
// .then(response => {
//   $(event.target).text('Added. Go to checkout?');
//   return response.json();
// })
// .catch((error) => {
//   $(event.target).text('Error.' + error);
//   console.error('Error:', error);
// });
  });
};

configuratorShareAndSave();